import * as React from "react";
type Props = {
  className?: string,
};
function SvgEggplant({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Eggplant"
      className={className}
    >
      <g clipPath="url(#clip0_1154_12327)">
        <path
          d="M28.4669 3.89333C29.0261 4.21857 29.5515 4.59782 30.0355 5.02552C30.2235 4.04274 30.5694 3.09622 31.06 2.22203C30.6471 2.18651 30.2478 2.05792 29.8927 1.84613C29.5375 1.63433 29.2359 1.34495 29.0109 1C28.8727 1.50692 28.6087 1.97141 28.2429 2.35124C27.877 2.73107 27.421 3.01408 26.9165 3.17444C27.448 3.38155 27.9658 3.62169 28.4669 3.89333Z"
          fill="white"
        />
        <path
          d="M29.9721 5.17813C29.7273 3.25521 28.5939 2.64426 26.8531 3.21933C26.0008 3.51586 22.6189 4.46833 23.0178 5.01645C23.0686 5.09646 23.1398 5.16183 23.2241 5.20599C23.3084 5.25015 23.403 5.27157 23.4984 5.26807C24.2256 5.37751 24.9654 5.37751 25.6926 5.26807C25.1304 8.59273 26.291 8.23325 28.3129 7.00222C28.3129 7.00222 29.0473 8.79935 29.1652 9.03297C29.1993 9.11895 29.2544 9.19516 29.3256 9.25476C29.3969 9.31437 29.4819 9.3555 29.5731 9.37443C30.3166 9.59907 29.9812 5.28595 29.9721 5.17813Z"
          fill="white"
        />
        <path
          d="M28.4669 3.89333C29.0261 4.21857 29.5515 4.59782 30.0355 5.02552C30.2235 4.04274 30.5694 3.09622 31.06 2.22203C30.6471 2.18651 30.2478 2.05792 29.8927 1.84613C29.5375 1.63433 29.2359 1.34495 29.0109 1C28.8727 1.50692 28.6087 1.97141 28.2429 2.35124C27.877 2.73107 27.421 3.01408 26.9165 3.17444C27.448 3.38155 27.9658 3.62169 28.4669 3.89333Z"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M8.42924 32.6741C5.83611 22.6821 15.7372 12.4655 18.2124 9.7249C21.1592 6.45415 23.0178 3.64167 26.5539 4.33356C29.4281 4.89965 30.9423 7.8559 28.6575 10.6235C24.5502 15.5476 24.0695 16.8504 23.7885 20.1212C23.4439 24.0658 24.396 31.1465 22.9453 34.3274C20.0167 40.6533 9.85274 38.2991 8.42924 32.6741Z"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M29.9721 5.17813C29.7273 3.25521 28.5939 2.64426 26.8531 3.21933C26.0008 3.51586 22.6189 4.46833 23.0178 5.01645C23.0686 5.09646 23.1398 5.16183 23.2241 5.20599C23.3084 5.25015 23.403 5.27157 23.4984 5.26807C24.2256 5.37751 24.9654 5.37751 25.6926 5.26807C25.1304 8.59273 26.291 8.23325 28.3129 7.00222C28.3129 7.00222 29.0473 8.79935 29.1652 9.03297C29.1993 9.11895 29.2544 9.19516 29.3256 9.25476C29.3969 9.31437 29.4819 9.3555 29.5731 9.37443C30.3166 9.59907 29.9812 5.28595 29.9721 5.17813Z"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
      </g>
      <defs>
        <clipPath id="clip0_1154_12327">
          <rect width={40} height={40} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
export default SvgEggplant;
